import { useCallback } from 'react'
import { useTranslator } from '@hooks/useTranslator'
import { logger } from '@core/logger'
import { useGetLocale } from '@hooks/useGetLocale'

const warnedMissingKeys: string[] = []

export const useLocaliseString = () => {
  const { translations = {}, loading } = useTranslator()
  const locale = useGetLocale()

  const localiseString = useCallback(
    (key: string) => {
      const translation = translations?.[key]

      const isMissingKey = typeof translation === 'undefined'
      const hasBeenWarned = isMissingKey && warnedMissingKeys.includes(key)

      if (!loading && isMissingKey && !hasBeenWarned) {
        logger.warn('MISSING_TRANSLATION_KEY', { key, locale })
        warnedMissingKeys.push(key)
      }

      return translation || key
    },
    [translations, locale, loading]
  )

  return localiseString
}
